import type { Channel } from "phoenix"

export const promisifyPush = ({
  channel,
  eventName,
  payload
}: {
  channel: Channel
  eventName: string
  payload?: object
}) => {
  return new Promise((resolve, reject) => {
    channel
      .push(eventName, payload || {})
      .receive('ok', (result) => {
        resolve(result)
      })
      .receive('error', (error) => {
        reject(error)
      })
  })
}